import BaseInterpretation from "./BaseInterpretation";

export default class InvestigationSynthesis extends BaseInterpretation {
  static entity = "investigationSyntheses";
  static primaryKey = "uuid";

  static fields() {
    return {
      ...super.fields(),
      synthesisPlans: this.attr([]),
      synthesisText: this.string(""),
    };
  }
}
